<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="비밀번호 찾기" :type="'empty'" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="resultMsg error onlyMsg">
            <p class="copy">
              웰몰에 가입된 정보가
              <br />
              확인되지 않습니다.
            </p>
            <p class="desc">
              입력된 정보가 정확하지 않습니다.
              <br />
              정확한 정보를 다시 입력해주세요.
            </p>
          </div>

          <div class="btnArea sticky two half">
            <!--<button type="button" class="btn_s" @click="$router.push('/login/findPwd')">
              확인
            </button>-->
            <button type="button" class="btn_s" @click="$router.replace('/login')">
              확인
            </button>
            <button type="button" class="btn_p" @click="$router.push('/join/joinStep1')">
              회원가입
            </button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
export default {
  name: 'findPwdResult',
  data: function() {
    return {
      headerTitle: '비밀번호 찾기',
    };
  },
};
</script>
